
import React from 'react';

import ReactDOM from 'react-dom';
import { Button } from '@jd/find-react';

 

import KeeVue from '../base/KeeVue.js'



import $ from 'jquery';


export default class FsButton extends KeeVue {
	constructor(props) {
		super(props);
		var randId = this.getRandString();
		this.state =  {
			isShow: false,
			randId: randId,
			downloadPath: '',
			disabled: false,
		}

	}

	componentWillMount(){
		var that = this;

		this.registComponent();

		// if(this.props.component.style.position==='absolute')
		// {
		// 	this.setVueAttr(this.props.component.style,"overflow","visible");
		// 	if(this.props.component.style.width===null||this.props.component.style.width==="")
		// 	{
		// 		// this.setVueAttr(this.props.component.style,"width",(this.$refs.fsNode.offsetWidth+8)+"px");
		// 		// this.setVueAttr(this.props.component.style,"height",(this.$refs.fsNode.offsetHeight+8)+"px");
		// 		this.props.component.style.display = "inline-block";
		// 	}
		// }
		// else
		// {
		// 	this.setVueAttr(this.props.component.style,"position","");
		// 	this.setVueAttr(this.props.component.style, "width", "");
		// 	this.setVueAttr(this.props.component.style, "height", "");
		// 	this.setVueAttr(this.props.component.style, "top", "0");
		// 	this.setVueAttr(this.props.component.style, "left", "0");
		// }
	}

	setTitle=(title)=> {
		this.props.component.cp.title = title;
	}
	download=(url)=> {
		this.state.downloadPath = window.getFullUrl(url);
		this.refresh();
		var that = this;
		 
		setTimeout(function() {
			document.getElementById(that.state.randId + "downlink").click();
		}, 100);
	}
	disable=()=> {
		this.state.disabled = true;
		this.refresh();
	}
	enable=()=> {
		this.state.disabled = false;
		this.refresh();
	}
	sendClick=(item)=> {
		var that = this;
		console.log("buttond click event,item.cp.buttonType="+item.cp.buttonType);
		if(this.props.debug !== true) {
			if(this.isNotBlank(item.cp.buttonType)) {
				if(item.cp.buttonType === "submit") {
					
					//alert("this.props.thisForm.alias:"+this.props.thisForm.alias);
					window.CReactMap[this.props.component.viewName][this.props.thisForm.alias].submitButton = that;
					window.CReactMap[this.props.component.viewName][this.props.thisForm.alias].submitForm();
				}
				if(item.cp.buttonType === "cancel") {
					this.$emit("command", "cancel", item, this.props.po, this.props.thisForm, this.props.parentForm);
					return ;
				}
				if(item.cp.buttonType === "reset") {
					window.CReactMap[this.props.thisForm.alias].resetForm();
				}
				if(item.cp.buttonType === "close") {
					this.$emit("command", "close", item, this.props.po, this.props.thisForm, this.props.parentForm);
					return ;
				}
				if(item.cp.buttonType === "add") {
					if(this.isNotBlank(item.cp.childFormAlias)) {
						if(window.CReactMap[this.props.component.viewName][item.cp.childFormAlias] !== null) {
							window.CReactMap[this.props.component.viewName][item.cp.childFormAlias].addForm(item.cp.childFormAlias);
						} else {
							alert("未找到组件：" + item.cp.childFormAlias);
						}
					} else {
						alert("请设置要添加的子表单的别名！");
					}
				}
				if(item.cp.buttonType === "remove") {
				}
				if(item.cp.buttonType === "query") {
					if(window.CReactMap[this.props.component.viewName][item.cp.gridAlias] === null) {
						alert("表格别名设置错误，请重新设置！");
						return;
					}
					window.CReactMap[this.props.component.viewName][item.cp.gridAlias].query(window.CReactMap[this.props.component.viewName][this.props.thisForm.alias].getData());
				}
				this.$emit("command", item.cp.buttonType, item, this.props.po, this.props.thisForm, this.props.parentForm);
			} else {
				console.log("发送消息sendClick：" + item.alias + ".click" + "::");
				window.CReactMap[item.viewName].$emit(item.alias + ".click", item, this.props.po, this.props.thisForm, this.props.parentForm);
			}
		}
	}

	render(){
		var size = this.props.component.cp.size;
		
		if(size=='mini')
		{
			size='small';
		}
		else
		if(size=='small'||size=='normal')
		{
			size='defalut';
		}
		else
		{
			size='large';
		}
		 

		return(

			<div   className={`kee-fs-button`} >
				<Button 
						onClick={(e)=>{e.stopPropagation();this.sendClick(this.props.component)}}
						size={size}
						type={this.props.component.cp.type=='text'?'link':this.props.component.cp.type}
						disabled={this.state.disabled||this.props.component.cp.disabled}
						danger={this.props.component.cp.danger}
						shape={this.props.component.cp.shape}
						block={this.props.component.cp.block}
						{...this.props.component.extProps}
						>
					{
						this.props.component.cp.icon&&<i className={`${this.state.disabled===true?'el-icon-loading':this.props.component.cp.icon}`} ></i>
					}
					{ this.state.disabled===true?'正在提交':(this.props.component.cp.title&&this.props.component.cp.icon ?' '+this.props.component.cp.title:this.props.component.cp.title)}

					


					{ this.props.debug===true&&this.props.component.cp.field&&  <div  >
						[{this.props.component.cp.field}]
					</div> }
					{ this.props.po&&this.props.component.cp.field&&  <div  >
						{  this.getAttr(this.props.po,this.props.component.cp.field)}
					</div> }


				</Button>
				<div style={{display:' none'}} >
					<a id={this.state.randId+'downlink'} href={this.state.downloadPath} >
						下载
					</a>
				</div>
			</div>
		);}
}
